<template>
  <div>
    <q-dialog v-model="saveModelDig" persistent style="width: 800px">
      <q-card>
        <q-bar class="bg-primary text-white">
          Save as
          <q-space />
          <q-btn v-close-popup text-color="white" dense size="sm" icon="close">
            <q-tooltip class="bg-white text-primary">Close</q-tooltip>
          </q-btn>
        </q-bar>

        <q-card-actions align="right" class="q-pa-md">
          <!-- :rules="[
              (val) =>
                !savedCustomSignalData?.some(
                  (i) =>
                    i.name.toLowerCase() ==
                    customSignalData.model_name.toLowerCase()
                ) || 'You have already saved model with this name.',
            ]" -->
          <q-input
            ref="modelNameRef"
            label="Model Name"
            v-model="modelNam"
          ></q-input>
          <q-btn
            flat
            label="Save"
            color="primary"
            v-close-popup
            :disable="
              modelNam == null || modelNam == ''
              // savedCustomSignalData?.some(
              //   (i) =>
              //     i.name.toLowerCase() ==
              //     customSignalData?.model_name.toLowerCase()
              // )
            "
            @click="submitSetup()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch } from "vue";
export default {
  name: "SaveDialog",
  props: {
    modelName: {
      type: String,
      default: () => "",
    },
    saveModelDialog: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["changeModelName", "changeModelDialog"],
  setup(props, context) {
    let saveModelDig = ref(props.saveModelDialog);
    let modelNam = ref(props.modelName);
    const modelNameRef = ref(null);

    const focusModelName = () => {
      setTimeout(() => {
        modelNameRef.value.focus();
      }, 100);
    };
    watch(
      () => props.saveModelDialog,
      (newVal, oldVal) => {
        saveModelDig.value = newVal;
        modelNam.value = props.modelName;
        if (newVal) focusModelName();
      }
    );

    watch(saveModelDig, (newVal, oldVal) => {
      context.emit("changeModelDialog", saveModelDig.value);
    });

    function submitSetup() {
      context.emit("changeModelName", modelNam.value);
      context.emit("changeModelDialog", saveModelDig.value);
      context.emit("submitSetup");
    }

    return {
      modelNameRef,
      saveModelDig,
      modelNam,
      submitSetup,
    };
  },
};
</script>
